<template>
  <div style="padding: 20px; height: 100%; box-sizing: border-box">
    <div class="cf" style="padding:10px 0">
      <div class="fl">
        <el-button type="success" size="mini" @click="handleShopDataReresh()" style="margin-right: 10px;">
          数据刷新
        </el-button>
        <el-radio-group v-model="type" @change="handleChangeType()" size="mini" style="margin-right: 10px;">
          <el-radio-button label="0">场站</el-radio-button>
          <el-radio-button label="1">企业</el-radio-button>
          <el-radio-button label="2">园区</el-radio-button>
          <el-radio-button label="5">报价</el-radio-button>
          <el-radio-button label="6">化验室</el-radio-button>
          <el-radio-button label="4">推荐</el-radio-button>
          <el-radio-button label="3">咨询</el-radio-button>
        </el-radio-group>
        <el-input v-model="search.name" @change="fetchInit()" style="width: 120px" placeholder="名称" clearable
          size="mini" v-if="isShopType || isProductType || isCoalType"></el-input>
        <el-input v-model="search.name" @change="fetchInit()" style="width: 120px" placeholder="关键字搜索" clearable
          size="mini" v-if="isRecommendType"></el-input>
        <el-input v-model="search.tenant_shop_id_name" @change="fetchInit()" style="width: 120px; margin-left: 10px;"
          placeholder="商铺" clearable size="mini" v-if="isProductType"></el-input>
        <el-input v-model="search.create_tenant_name" @change="fetchInit()" style="width: 120px; margin: 0 10px;"
          placeholder="企业" clearable size="mini" v-if="isShopType || isProductType || isCoalType"></el-input>
        <el-input v-model="search.phone" @change="fetchInit()" style="width: 120px; margin-right: 10px;"
          placeholder="手机号" clearable size="mini" v-if="isConsultType"></el-input>
        <el-select v-model="search.type" @change="fetchInit()" style="width: 100px; margin-right: 10px;"
          placeholder="类型" clearable size="mini" v-if="isConsultType">
          <el-option v-for="item in ['咨询', '认领', '反馈']" :key="item" :value="item" :label="item"></el-option>
        </el-select>
        <el-select v-model="search.sub_type" @change="fetchInit()" style="width: 100px; margin-right: 10px;"
          placeholder="类型" clearable size="mini" v-if="isTenantShopType">
          <el-option v-for="item in ['煤商', '运力', '服务商']" :key="item" :value="item" :label="item"></el-option>
        </el-select>
        <el-input v-model="search.platform_id_name" @change="fetchInit()" style="width: 120px; margin-right: 10px;"
          placeholder="场站" clearable size="mini" v-if="isAllPlatformType"></el-input>
        <el-select v-model="search.manual_recommend" @change="fetchInit()" style="width: 100px;" placeholder="是否推荐"
          clearable size="mini" v-if="isShopType || isProductType || isCoalType">
          <el-option v-for="item in [{ value: true, label: '是' }, { value: false, label: '否' }]" :key="item.value"
            :value="item.value" :label="item.label"></el-option>
        </el-select>
        <el-select v-model="search.state" @change="fetchInit()" style="width: 100px; margin-left: 10px;"
          placeholder="状态" clearable size="mini" v-if="isShopType || isProductType || isCoalType">
          <el-option v-for="item in [{ value: 'Draft', label: '未上架' }, { value: 'Done', label: '已上架' }]"
            :key="item.value" :value="item.value" :label="item.label"></el-option>
        </el-select>
        <el-select v-model="search.digital_system" @change="fetchInit()" style="width: 100px; margin-left: 10px;"
          placeholder="数字化系统" clearable size="mini" v-if="isPlatformType">
          <el-option v-for="item in [{ value: true, label: '已开通' }, { value: false, label: '未开通' }]" :key="item.value"
            :value="item.value" :label="item.label"></el-option>
        </el-select>
        <el-select v-model="search.claim" @change="fetchInit()" style="width: 100px; margin-left: 10px;"
          placeholder="认领" clearable size="mini" v-if="isPlatformType">
          <el-option v-for="item in [{ value: true, label: '已认领' }, { value: false, label: '未认领' }]" :key="item.value"
            :value="item.value" :label="item.label"></el-option>
        </el-select>
      </div>
      <div class="fr">
        <el-tooltip class="item" effect="dark" content="查询" placement="top">
          <el-button size="mini" @click="init()" circle icon="el-icon-search">
          </el-button>
        </el-tooltip>
      </div>
    </div>
    <div :style="{ height: !isRecommendType ? '85%' : '90%' }">
      <el-table :data="data" border size="mini" style="width: 100%" height="100%" v-loading="loading"
        highlight-current-row ref="tableRef" :key="type" @sort-change="handleSortChange"
        :row-class-name="handleRowClassName">
        <template #empty>
          <el-empty></el-empty>
        </template>
        <el-table-column type="index" label="行号" width="50" align="center" />
        <el-table-column prop="name" label="商铺" min-width="200" show-overflow-tooltip align="center"
          v-if="isShopType" />
        <el-table-column type="sub_type" label="类型" width="100" align="center" v-if="isTenantShopType">
          <template #default="{ row }">
            <el-tag :type="row.sub_type === '煤商' ? 'success' : row.sub_type === '服务商' ? 'danger' : 'primary'"
              size="mini" effect="dark">
              {{ row.sub_type }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称" min-width="200" v-if="isRecommendType || isProductType || isCoalType"
          show-overflow-tooltip align="center" />
        <el-table-column prop="tenant_shop_id_name" label="商铺" min-width="150" v-if="isProductType"
          show-overflow-tooltip align="center" />
        <el-table-column prop="create_tenant_name" label="企业" min-width="150" show-overflow-tooltip align="center"
          v-if="isShopType || isProductType || isCoalType" />
        <el-table-column prop="phone" label="手机号" width="200" align="center" v-if="isConsultType" />
        <el-table-column prop="remark" label="需求" min-width="200" show-overflow-tooltip align="center"
          v-if="isConsultType" />
        <el-table-column prop="map_remark" label="地图纠错" min-width="200" show-overflow-tooltip align="center"
          v-if="isConsultType" />
        <el-table-column prop="platform_id_name" label="场站" width="150" v-if="isAllPlatformType" show-overflow-tooltip
          align="center" />
        <el-table-column prop="tags" label="标签" width="280" align="center" v-if="isShopType">
          <template #default="{ row }">
            <el-tag v-for="(tag, index) in toSelect(row.tags)" :key="index" style="margin-right: 5px;" size="mini"
              v-if="row.tags" effect="dark">
              {{ tag }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="score" label="评分" width="45" align="center" v-if="isShopType">
          <template #default="{ row }">
            <div style="font-size: 16px;">
              <span style="color: #99A9BF" v-if="row.score < 3">{{ row.score }}</span>
              <span style="color: #F7BA2A" v-else-if="row.score >= 3 && row.score < 5">{{ row.score }}</span>
              <span style="color: #7BC139" v-else-if="row.score === 5">{{ row.score }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="类型" width="120" align="center" v-if="isConsultType">
          <template #default="{ row }">
            <el-tag :type="row.type === '咨询' ? 'primary' : row.type === '认领' ? 'success' : 'warning'" size="mini"
              effect="dark">
              {{ row.type }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="类型" width="120" v-if="isRecommendType" align="center">
          <template #default="{ row }">
            <el-tag :type="handleToRecommend(row).type" size="mini" effect="dark">
              {{ handleToRecommend(row).label }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="rankScore" label="推荐评分" width="100" v-if="isRecommendType" align="center" />
        <el-table-column prop="deliveryName" label="交货地" width="200" align="center" v-if="isRecommendType"
          show-overflow-tooltip />
        <el-table-column prop="place_of_delivery_id_name" width="150" label="交货地" align="center" v-if="isProductType"
          show-overflow-tooltip />
        <el-table-column prop="priceType" label="价格类型" width="150" align="center" v-if="isRecommendType" />
        <el-table-column prop="type" label="价格类型" align="center" width="100" v-if="isProductType" />
        <el-table-column prop="price" label="价格" align="center" width="100" v-if="isRecommendType || isProductType" />
        <el-table-column prop="description" label="描述" align="center" v-if="isCoalType" min-width="300"
          show-overflow-tooltip />
        <el-table-column prop="qualification" label="认证" align="center" v-if="isCoalType" width="200">
          <template #default="{ row }">
            <template v-if="row.qualification">
              <el-tag v-for="(item, index) in JSON.parse(row.qualification)" type="primary" size="mini" effect="dark"
                style="margin-right: 5px" :key="index">
                {{ item.name }}
              </el-tag>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="update_time" label="更新时间" width="140" align="center"
          v-if="isShopType || isProductType || isCoalType || isConsultType" />
        <el-table-column prop="create_time" label="创建时间" width="140" align="center" sortable="custom"
          v-if="isShopType || isProductType || isCoalType || isConsultType" />
        <el-table-column prop="manual_recommend" label="推荐" width="45" align="center"
          v-if="isShopType || isProductType || isCoalType">
          <template #default="{ row }">
            <el-tag :type="row.manual_recommend ? 'success' : 'danger'" size="mini" effect="dark">
              {{ row.manual_recommend ? '是' : '否' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="state" label="状态" width="70" align="center"
          v-if="isShopType || isProductType || isCoalType">
          <template #default="{ row }">
            <el-tag :type="row.state === 'Done' ? 'success' : 'danger'" size="mini" effect="dark">
              {{ row.state === 'Done' ? '已上架' : '未上架' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="digital_system" label="数字化系统" width="85" align="center" v-if="isPlatformType">
          <template #default="{ row }">
            <el-tag :type="row.digital_system ? 'success' : 'danger'" size="mini" effect="dark">
              {{ row.digital_system ? '已开通' : '未开通' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="claim" label="认领" width="70" align="center" v-if="isPlatformType">
          <template #default="{ row }">
            <el-tag :type="row.claim ? 'success' : 'danger'" size="mini" effect="dark">
              {{ row.claim ? '已认领' : '未认领' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center" fixed="right" v-if="!isConsultType">
          <template #default="{ row }">
            <template v-if="!isRecommendType">
              <el-button type="text" size="mini" @click="handleUpdate(row)" v-if="isShopType">更新</el-button>
              <el-button type="text" size="mini" @click="handleAssayUpdate(row)" v-if="isCoalType">更新</el-button>
              <el-button type="text" size="mini" @click="handleCheck(row)" v-if="isShopType">查看</el-button>
              <el-button type="text" size="mini" @click="handleToState(row, 'Done')" v-if="row.state === 'Draft'">
                上架
              </el-button>
              <el-button v-if="row.state === 'Done' && isProductType" size="mini" type="text"
                @click="handleAddSpecial(row)">
                绑定专题
              </el-button>
              <el-button type="text" size="mini" @click="handleRecommendUpdate(row)"
                v-if="!row.manual_recommend && row.state === 'Done'">
                推荐
              </el-button>
              <el-button type="text" size="mini" @click="handleToState(row, 'Draft')" style="color: #F56C6C"
                v-if="row.state === 'Done' && !row.manual_recommend">
                下架
              </el-button>
              <el-button type="text" style="color: #F56C6C" size="mini" @click="handleRecommendDel(row)"
                v-if="row.manual_recommend">解除</el-button>
            </template>
            <template v-if="isRecommendType">
              <el-button type="text" size="mini" @click="handleRecommendUpdate(row)">
                更新推荐评分
              </el-button>
              <el-button type="text" style="color: #F56C6C" size="mini" @click="handleRecommendDel(row)">解除</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="text-align: left; padding: 10px 0" v-if="type !== '4'">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page.current"
        :page-sizes="[20, 50, 80, 100, 200]" :page-size="page.size" layout="total, sizes, prev, pager, next, jumper"
        :total="page.total" background>
      </el-pagination>
    </div>
    <update ref="updateRef" @init="init" />
    <assay-update ref="assayUpdateRef" @init="init" />
    <shop-check ref="shopCheckRef" @init="init" />
    <recommend-update ref="recommendUpdateRef" @init="init" />
    <shopSpecialContentAdd ref="shopSpecialContentAddRef" />
  </div>
</template>

<script>
import Update from './components/update.vue'
import ShopCheck from './components/shopCheck.vue'
import RecommendUpdate from './components/recommendUpdate.vue'
import AssayUpdate from './components/assayUpdate.vue'
import ShopSpecialContentAdd from '@/components/shopSpecialContentAdd.vue'

export default {
  data() {
    return {
      data: [],
      allAlign: 'center',
      loading: false,
      page: {
        total: 0,
        size: 20,
        current: 1
      },
      search: {
        name: '',
        create_tenant_name: '',
        platform_id_name: '',
        phone: '',
        type: '',
        manual_recommend: '',
        tenant_shop_id_name: '',
        state: '',
        digital_system: '',
        claim: '',
        sub_type: ''
      },
      operators: ['manual_recommend', 'state', 'digital_system', 'claim', 'sub_type'],
      type: '0',
      sorts: [{ field: 'update_time', desc: true }]
    }
  },
  computed: {
    isShopType() {
      return ['0', '1', '2'].includes(this.type)
    },
    isAllPlatformType() {
      return ['0', '2', '3'].includes(this.type)
    },
    isTenantShopType() {
      return this.type === '1'
    },
    isConsultType() {
      return this.type === '3'
    },
    isRecommendType() {
      return this.type === '4'
    },
    isProductType() {
      return this.type === '5'
    },
    isCoalType() {
      return this.type === '6'
    },
    isPlatformType() {
      return this.type === '0'
    }
  },
  components: { Update, ShopCheck, RecommendUpdate, AssayUpdate, ShopSpecialContentAdd },
  mounted() {
    this.$set(this, 'type', '0')
    this.$set(this, 'sorts', [{ field: 'update_time', desc: true }])
    this.init()
    this.$validate.ToDocumentTitle()
  },
  methods: {
    handleChangeType() {
      this.search = {
        name: '',
        create_tenant_name: '',
        platform_id_name: '',
        phone: '',
        type: '',
        manual_recommend: '',
        tenant_shop_id_name: '',
        state: '',
        digital_system: '',
        claim: '',
        sub_type: ''
      }
      this.$set(this, 'sorts', [{ field: 'update_time', desc: true }])
      this.fetchInit()
    },
    fetchInit() {
      this.page.current = 1
      this.init()
    },
    init() {
      this.$set(this, 'loading', true)
      this.$set(this, 'data', [])
      let params = {}
      if (this.isRecommendType) {
        if (this.search.name) {
          params = {
            params: {
              name: this.search.name
            }
          }
        }
      } else {
        let conditions = []
        for (const key in this.search) {
          if (this.search[key] || (!this.search[key] && this.search[key] === false)) {
            conditions.push({ field: key, operator: this.operators.includes(key) ? '=' : 'like', value1: this.search[key] })
          }
        }
        params = {
          conditions: conditions,
          pageNum: this.page.current,
          pageSize: this.page.size,
          sorts: this.isShopType || this.isProductType || this.isCoalType ? this.sorts : []
        }
      }
      let url
      if (this.type === '0') {
        url = this.$axios.post('/paas/sys_shop/list', params)
      } else if (this.type === '1') {
        url = this.$axios.post('/paas/sys_tenant_shop/list', params)
      } else if (this.type === '2') {
        url = this.$axios.post('/paas/sys_park_shop/list', params)
      } else if (this.type === '3') {
        url = this.$axios.post('/paas/sys_shop_consult/list', params)
      } else if (this.type === '4') {
        url = this.$axios.get('/account/shop/recommend/list', params)
      } else if (this.type === '5') {
        url = this.$axios.post('/paas/sys_tenant_shop_quotation/list', params)
      } else if (this.type === '6') {
        url = this.$axios.post('/paas/coal_laboratory/list', params)
      }
      url.then(res => {
        if (this.type !== '4') {
          this.$set(this, 'data', res.data.data.list || [])
          this.$set(this.page, 'total', res.data.data.total)
        } else {
          this.$set(this, 'data', res.data.data)
        }
        this.$nextTick(() => {
          this.$set(this, 'loading', false)
          this.$refs.tableRef.doLayout()
        })
      }).catch(err => {
        console.log('model Err:', err)
        this.$set(this, 'loading', false)
        this.$refs.tableRef.doLayout()
      })
    },
    handleSortChange(val) {
      this.sorts = val.order ? [{ field: val.prop, desc: 'descending' === val.order }] : [{ field: 'update_time', desc: true }]
      this.fetchInit()
    },
    handleSizeChange(val) {
      this.page.size = val
      this.init()
    },
    handleRowClassName() {
      return 'shop-update-table-background'
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.init()
    },
    handleUpdate(row) {
      const event = {
        type: this.type,
        data: row
      }
      this.$refs.updateRef.display(event)
    },
    handleAssayUpdate(row) {
      this.$axios.get(`/laboratory/coal_laboratory/query?id=${row.id}`).then((res) => {
        const event = {
          data: res.data.data
        }
        this.$refs.assayUpdateRef.display(event)
      })
    },
    handleCheck(row) {
      const event = {
        type: this.type,
        data: row
      }
      this.$refs.shopCheckRef.display(event)
    },
    handleRecommendUpdate(row) {
      const dataType = this.isProductType ? 'TenantProduct' : this.isCoalType ? 'Laboratory' : row.type
      const event = {
        data: {
          id: row.id,
          name: row.name,
          type: dataType,
          score: row.rankScore ? Number(row.rankScore) : 3,
          uuid: row.uuid || ''
        }
      }
      this.$refs.recommendUpdateRef.display(event)
    },
    handleRecommendDel(row) {
      const dataType = this.isProductType ? 'TenantProduct' : this.isCoalType ? 'Laboratory' : row.type
      this.$confirm(`确定解除 ${row.name} 吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          id: row.id,
          type: dataType,
          uuid: row.uuid
        }
        this.$axios.post('/account/shop/recommend/score/remove', params).then(() => {
          this.$message.success(`解除成功`)
          this.init()
        })
      }).catch(() => { })
    },
    toSelect(tags) {
      return tags && this.isShopType ? tags.split(',') : []
    },
    handleAddSpecial(row) {
      this.$refs.shopSpecialContentAddRef.display({ row: row, type: 'TenantProduct' })
    },
    handleToRecommend(row) {
      let type = 'info'
      let label = '化验室'
      if (row.type === 'Tenant') {
        type = 'success'
        label = '企业'
      } else if (row.type === 'Platform') {
        type = 'primary'
        label = '场站'
      } else if (row.type === 'TenantProduct') {
        type = 'warning'
        label = '报价'
      } else if (row.type === 'Park') {
        type = 'danger'
        label = '园区'
      }
      return { type, label }
    },
    handleToState(row, state) {
      const params = {
        id: row.id,
        state: state
      }
      let url
      if (this.type === '0') {
        url = this.$axios.post('/paas/eventEmit/emit/sys_shop/sys_shop_update', params)
      } else if (this.type === '1') {
        url = this.$axios.post('/paas/eventEmit/emit/sys_tenant_shop/sys_tenant_shop_update', params)
      } else if (this.type === '2') {
        url = this.$axios.post('/paas/eventEmit/emit/sys_park_shop/sys_park_shop_update', params)
      } else if (this.type === '5') {
        url = this.$axios.post('/paas/eventEmit/emit/sys_tenant_shop_quotation/tenant_shop_quotation_update_contact', params)
      } else if (this.type === '6') {
        url = this.$axios.post('/paas/eventEmit/emit/coal_laboratory/coal_laboratory_update', params)
      }
      url.then(() => {
        if (state === 'Done') {
          this.$message.success({ showClose: true, message: '上架成功' })
        } else {
          this.$message.success({ showClose: true, message: '下架成功' })
        }
        this.init()
      })
    },
    handleShopDataReresh() {
      this.$axios.post('/account/shop/homepage/search/dataRefresh').then(() => {
        this.$message.success({ showClose: true, message: '刷新成功' })
      }).catch(() => { })
    }
  }
}
</script>

<style scoped>
.cf {
  overflow: hidden
}

.fl {
  float: left;
}

.fr {
  float: right;
}
</style>
<style>
.shop-update-table-background {
  background-color: #fff !important;
}
</style>